   // Function to check for the existence of the textarea, input, and the URL
  jQuery(document).ready(function($) {
function checkElementsAndUrl() {
      var textarea = $("textarea.pplr_text");
      var input = $("input.pplr_text");
      var currentUrl = window.location.href;

      // Check if the current URL contains "/products/"
      if (currentUrl.includes("/products/")) {
        // Prepend the content before the textarea and input, and clear the interval
        if (textarea.length > 0) {
          textarea.before('<div class="warning"><p>Please make sure that the spelling is correct</p></div>');
        }
        if (input.length > 0) {
          input.before('<div class="warning"><p>Please make sure that the spelling is correct</p></div>');
        }

        clearInterval(interval);
      }
    }

    // Set up a timer to check every 500 milliseconds
    var interval = setInterval(checkElementsAndUrl, 500);
});

jQuery(document).ready(function($) {
  // Function to check and toggle button visibility based on the number of .byob-footer-card elements
  function checkAndToggleButton() {
    var byobFooterCards = $('body.product-byob .byob-wrapper .byob-footer-card');
    
    if (byobFooterCards.length === 1) {
      $('body.product-byob button#btn-add-to-cart').hide();
    } else if (byobFooterCards.length === 2) {
      $('body.product-byob button#btn-add-to-cart').show();
    }
  }

  // Initial check
  checkAndToggleButton();

  // Create a MutationObserver to watch for changes within the specified context
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      // Check and toggle the button whenever a mutation occurs
      checkAndToggleButton();
    });
  });

  // Define the target node and options for the observer
  var targetNode = document.querySelector('body.product-byob .byob-wrapper');
  var config = { childList: true, subtree: true };

  // Start observing the target node for mutations
  observer.observe(targetNode, config);
});

jQuery(document).ready(function($){
    setTimeout(function(){
        if(window.location.href.indexOf("armed-forces") > -1){
            $("input#color-brown").click();
            $("input#color-green").click();
            $("input#color-khaki").click();
        }
    }, 500); // 1 second delay
});


jQuery(document).ready(function($){
    setTimeout(function(){
        if(window.location.href.indexOf("happy-birthday-america") > -1){
            $("input#color-red").click();
            $("input#color-blue").click();
            $("input#color-white").click();
            $("input#color-blue-black").click();
            $("input#color-red-black").click();
            $("input#color-teal").click();
        }
    }, 500); // 1 second delay
});

jQuery(document).ready(function($) {
    // Check if the body has the class 'happy-birthday-america'
    if ($('body').hasClass('happy-birthday-america')) {
        // Find the image inside the specified container
        const $imageElement = $('.inner-hero.relative.text-light img');
        
        // Check if the image element exists
        if ($imageElement.length) {
            // Replace the src attribute of the image
            $imageElement.attr('src', 'https://cdn.shopify.com/s/files/1/0279/6204/8605/files/Polyester-American-flag-closeup-angle_1200x_6f382a44-8c9f-40a1-9cad-27146e4e2be9.jpg?v=1718898578');
        }
    }
});



document.querySelectorAll('.template-giveaway.page-giveaway #content a.button').forEach(function(button) {
    button.addEventListener('click', function (e) {
        e.preventDefault();
      console.log("test");
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'T9eykm']);
    });
});